export const ROUTE_SIGN_IN = '/sign-in';
export const ROUTE_SIGN_UP = '/sign-up';
export const ROUTE_SHOP_LIST_MAIN = '/shop-lists';
export const ROUTE_SHOP_LIST = '/shop-list/:id';
export const ROUTE_PRODUCTS = '/products';
export const ROUTE_PRODUCT_CATEGORIES = '/product-categories';
export const ROUTE_RECIPES = '/recipes';
export const ROUTE_RECIPE = '/recipe/:id';
export const ROUTE_HOME = '/';
